import React from "react";
import { Modal, ModalHeader, ModalBody, Fade } from "reactstrap";
import AddModuleToCourseForm from "../Forms/AddModuleToCourseForm";

export default function CreateModule({
  isOpen,
  toggle,
  createNew,
  updateModule,
  courseName,
  reloadModules,
  modules,
  courseId,
  createdModuleId,
}) {
  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>
        <span className="fa fa-plus-circle" /> "Lägg till befintlig modul i: "
        {courseName}
      </ModalHeader>
      <ModalBody>
        <div>
          <Fade
            in={!createNew}
            tag="div"
            style={{ maxWidth: "95%" }}
            className={createNew ? "d-none" : "animated flipInX"}
          >
            <AddModuleToCourseForm
              updateModule={updateModule}
              dismissModal={toggle}
              reloadModules={reloadModules}
              modules={modules}
              courseId={courseId}
              selectModule={createdModuleId}
            />
          </Fade>
        </div>
      </ModalBody>
    </Modal>
  );
}
